export function base64ToString(data) {
    /** Convert Base64 data to a string */
    var toBinaryTable = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
        15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1
    ];
    var result = '';
    var leftbits = 0; 
    var leftdata = 0;                                                                             
    for (var i = 0; i < data.length; i++) {
        var c = toBinaryTable[data.charCodeAt(i) & 0x7f];
        var padding = (data.charCodeAt(i) == '='.charCodeAt(0)); 
        if (c == -1) continue;
        leftdata = (leftdata << 6) | c;
        leftbits += 6;
        if (leftbits >= 8) {
            leftbits -= 8;
            if (!padding)
                result += String.fromCharCode((leftdata >> leftbits) & 0xff);
            leftdata &= (1 << leftbits) - 1;
        }
    }                        
    // if (leftbits)
    //     throw Components.Exception('Corrupted base64 string');
    return result;
}

export function CharToHex(str) {
var out, i, h;
out = "";
i = 0;
while(i < str.length) 
{
    h = str.charCodeAt(i++).toString(16).toUpperCase();
    if(h.length==1){
        out += "0" +h
    }else{
        out += ""+h;
    }
    
    
    console.log(`99`,out)
    out +=(i > 0 && i % 8 == 0)?"":",";
    // console.log(`99`,out)
}
return out;
}
export function getLocalTime(nS) {     
    return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');     
 }
export function formatDate (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
    };
    for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
    let str = o[k] + '';
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
    }
    return fmt;
}

function padLeftZero (str) {
    return ('00' + str).substr(str.length);
}